// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2f822dd7","453":"127be8e2","455":"9f1b5cc0","977":"f9826cbd"}[chunkId] + ".chunk.js";
};